module.exports = __webpack_public_path__ + "static/media/DCH-9.5245f299.png";